
import { Placement } from '@post-office/placements-frontend/search-page-results-inline';
export default Placement;
